module.exports = __webpack_public_path__ + "img/intratuin-logo.5cbca60c.png";